// @flow weak

import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../redux/modules/actions';
import InvoicesList   from './InvoicesList';

export default InvoicesList;



// WEBPACK FOOTER //
// ./src/app/views/invoices/index.js